import { translate } from '../../../common/utility/DisplayPrep';
const defaultUiConfig = {
    name: 'Value Sets',
    withActions: [],
    primaryKey: 'valueSetId',
    pageSize: 10,
    properties: {
        oid: {
            sortable: true,
            name: 'Oid',
            rowDisplay: false
            // accessorOverride: (v) => {
            //     if (v.mappingType === 'Value Set') {
            //         return v.valueSetDTO.oid;
            //     } else if (v.mappingType === 'Code') {
            //         return v.cdsCodeSystemDTO.oid;
            //     } else {
            //         return '';
            //     }
            // }
        },
        name: {
            name: 'Name',
            sortable: true,
            rowDisplay: false
            // accessorOverride: (v) => {
            //     // For now we must use the formatted value until we resolve display prep
            //     if (v.mappingType === 'Value Set') {
            //         return v.valueSetDTO.name;
            //     } else if (v.mappingType === 'Code') {
            //         return v.cdsCodeSystemDTO.name;
            //     } else {
            //         return '';
            //     }
            // }
        },
        code: {
            name: 'Code',
            sortable: true,
            nullable: false
        },
        auditId: {
            name: 'Audit ID',
            sortable: true,
            rowDisplay: false
        },
        uuid: {
            rowDisplay: false,
            name: 'Uuid'
        },
        lastModId: {
            rowDisplay: false,
            name: 'Last Modified ID'
        },
        lastModDatetime: {
            rowDisplay: true,
            displayPrep: 'FullDate',
            name: 'Last Modified Datetime',
            additionalProperties: {
                Cell: ({ cell: { value } }) => {
                    return translate.ReadableDateTimeColumn(value);
                }
            }
        },
        createId: {
            rowDisplay: false,
            name: 'Create ID'
        },
        createDatetime: {
            rowDisplay: false,
            name: 'Create Datetime'
        }
    },
    newDoc: {
        auditId: null,
        code: null,
        createDatetime: null,
        createId: null,
        description: null,
        dtoState: 'NEW',
        lastModDatetime: null,
        lastModId: null,
        name: null,
        oid: null,
        source: null,
        valueSetCdsCodeRels: [],
        valueSetId: null,
        valueSetSubValueSetRels: [],
        valueSetType: null,
        version: null,
        versionDescription: null,
        versionEffectiveDate: null,
        versionExpirationDate: null,
        versionStatus: null
    }
};

export default defaultUiConfig;
